// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2FaKM","additionalInfo":"AgreementModal_additionalInfo__2ad_1"};